export var EHighLow;
(function (EHighLow) {
    EHighLow["HIGH"] = "high";
    EHighLow["LOW"] = "low";
})(EHighLow || (EHighLow = {}));
